import {useState} from 'react';
import {useQueryClient, useMutation, QueryClient} from '@tanstack/react-query';
import {favoriteGif, unfavoriteGif} from '../api/apiClient';
import {useAuth} from '../context/AuthContext';
import {useModal} from '../context/ModalContext';

const useFavorite = () => {
    const queryClient: QueryClient = useQueryClient();
    const {storedUserData, setStoredUserData, getToken, getIsLoggedIn} = useAuth();
    const {handleJoinFormShow} = useModal();
    const token = getToken();
    const isAuth = getIsLoggedIn();
    const [favorite, setFavorite] = useState<any>('');


    const {mutate: favoriteGifMutate, isLoading: favLoading} = useMutation((id: any) => favoriteGif(id, token));
    const {mutate: unfavoriteGifMutate, isLoading: unFavLoading} = useMutation((id: any) => unfavoriteGif(id, token));
    const toggleFavorite = (gifId: any, queryInvalidateKey: string) => {
        setFavorite((favorite: any) => {
            if (isAuth) {
                if (favorite) {
                    unfavoriteGifMutate(gifId, {
                        onSuccess: async (favRes: any) => {
                            await queryClient.invalidateQueries({queryKey: [queryInvalidateKey]});
                            await queryClient.invalidateQueries({queryKey: ['/user/favourite/resources']});
                            setStoredUserData({
                                ...storedUserData,
                                favouriteImages: [...storedUserData?.favouriteImages.filter((item: any) => item !== gifId)]
                            });
                        }
                    });
                }

                if (!favorite) {
                    favoriteGifMutate(gifId, {
                        onSuccess: async (favRes: any) => {
                            await queryClient.invalidateQueries({queryKey: [queryInvalidateKey]});
                            await queryClient.invalidateQueries({queryKey: ['/user/favourite/resources']});
                            setStoredUserData({
                                ...storedUserData,
                                favouriteImages: [...storedUserData.favouriteImages, gifId]
                            });
                        }
                    });
                }

                return !favorite
            } else {
                handleJoinFormShow();
            }
        });
    };

    return {favorite, setFavorite, favLoading, unFavLoading, toggleFavorite};
};

export default useFavorite;